import React from 'react';
import { FEATURES_CONTENT } from '../../data/content';
import Ethereum from '../../Assets/Ethereum.png';

const FeaturesSection = () => {
  return (
    <section className="w-full bg-white px-4 sm:px-6 md:px-20 py-8 md:py-10" aria-label="Features">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-[1240px] mx-auto w-full">
        {FEATURES_CONTENT.map((feature, index) => (
          <div
            key={index}
            className="bg-[#F4F4F8] rounded-2xl p-5 md:p-6 flex flex-col"
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-delay={index * 100}
          >
            {/* Icon */}
            <div className="mb-6 md:mb-8">
              <img src={Ethereum} alt="icon" className="w-6 h-6 opacity-70" />
            </div>

            {/* Text */}
            <div>
              <h3
                className="mb-1 font-archivo font-semibold"
                style={{
                  fontSize: 'clamp(15px, 2.5vw, 17px)',
                  lineHeight: '140%',
                  color: '#18181B',
                }}
              >
                {feature.title}
              </h3>
              <p
                className="font-archivo font-medium"
                style={{
                  fontSize: 'clamp(14px, 2.5vw, 17px)',
                  lineHeight: '140%',
                  color: '#71717A',
                }}
              >
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
